// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8987dd4d","295":"8908efc2","726":"d6c53f3c","787":"3bbaab4b","911":"209ef0a1"}[chunkId] + ".chunk.js";
};